import { c as _c } from "react/compiler-runtime";
import { ChevronLeftIcon, ChevronRightIcon } from '@heroicons/react/20/solid';
import { isBefore, startOfMonth } from 'date-fns';
import { getDefaultClassNames, useDayPicker } from 'react-day-picker';
import { Button } from '@/frontend/design-system/actions/Button';
import { cn } from '@/frontend/utils';
type NavProps = {
  allowPast?: boolean;
};
export const Nav = t0 => {
  const $ = _c(18);
  const {
    allowPast: t1
  } = t0;
  const allowPast = t1 === undefined ? false : t1;
  const defaultClassNames = getDefaultClassNames();
  const context = useDayPicker();
  if (!context) {
    throw new Error("Empty DayPicker context");
  }
  let t2;
  if ($[0] !== allowPast || $[1] !== context.previousMonth) {
    t2 = !allowPast && (context.previousMonth ? isBefore(context.previousMonth, startOfMonth(new Date())) : true);
    $[0] = allowPast;
    $[1] = context.previousMonth;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const disablePrev = t2;
  const t3 = cn(defaultClassNames.nav, "flex w-full justify-between gap-2");
  let t4;
  if ($[3] !== context) {
    t4 = () => {
      context.goToMonth(context.previousMonth ?? new Date());
      context.dayPickerProps.onMonthChange?.(context.previousMonth ?? new Date());
    };
    $[3] = context;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <ChevronLeftIcon className="stroke-0 stroke-contentPrimary" />;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  let t6;
  if ($[6] !== disablePrev || $[7] !== t4) {
    t6 = <Button outline={true} size="sm" disabled={disablePrev} onClick={t4}>{t5}</Button>;
    $[6] = disablePrev;
    $[7] = t4;
    $[8] = t6;
  } else {
    t6 = $[8];
  }
  let t7;
  if ($[9] !== context) {
    t7 = () => {
      context.goToMonth(context.nextMonth ?? new Date());
      context.dayPickerProps.onMonthChange?.(context.nextMonth ?? new Date());
    };
    $[9] = context;
    $[10] = t7;
  } else {
    t7 = $[10];
  }
  let t8;
  if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = <ChevronRightIcon className="stroke-0 stroke-contentPrimary" />;
    $[11] = t8;
  } else {
    t8 = $[11];
  }
  let t9;
  if ($[12] !== t7) {
    t9 = <Button outline={true} size="sm" onClick={t7}>{t8}</Button>;
    $[12] = t7;
    $[13] = t9;
  } else {
    t9 = $[13];
  }
  let t10;
  if ($[14] !== t3 || $[15] !== t6 || $[16] !== t9) {
    t10 = <nav className={t3}>{t6}{t9}</nav>;
    $[14] = t3;
    $[15] = t6;
    $[16] = t9;
    $[17] = t10;
  } else {
    t10 = $[17];
  }
  return t10;
};